"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const outOfProcDataLabel = "\n\n$OutOfProcData$:";
class OrchestrationFailureError extends Error {
    constructor(error, state) {
        let errorMessage;
        if (error instanceof Error) {
            errorMessage = error.message;
        }
        else if (typeof error === "string") {
            errorMessage = error;
        }
        else {
            errorMessage = JSON.stringify(error);
        }
        const message = `${errorMessage}${outOfProcDataLabel}${JSON.stringify(state)}`;
        super(message);
        this.stack = error.stack;
    }
}
exports.OrchestrationFailureError = OrchestrationFailureError;
//# sourceMappingURL=orchestrationfailureerror.js.map